import { render } from "./Milestone.vue?vue&type=template&id=025ee710&ts=true"
import script from "./Milestone.vue?vue&type=script&lang=ts"
export * from "./Milestone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__